import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  popper: {
    zIndex: theme.zIndex.modal
  },
  paperMenu: {
    boxShadow: `0 5px 10px 0 ${theme.palette.web.shadowGrey}`,
    minWidth: 160
  },
  menuList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: `${theme.spacing(1)}px 0`,
    '& .MuiMenuItem-root': {
      display: 'flex',
      width: '100%',
      boxSizing: 'border-box'
    }
  }
}))
